import moment from 'moment';
import { useI18n } from 'vue-i18n-composable';

export default function useDateFormatter() {
  const DEFAULT_FORMAT = 'LLL';

  const { locale } = useI18n();

  function formatDateDefault(date) {
    return moment(date).locale(locale.value.toLowerCase()).format(DEFAULT_FORMAT);
  }

  function formatDate(date, format) {
    return moment(date).locale(locale.value.toLowerCase()).format(format);
  }

  return {
    formatDateDefault,
    formatDate,
  };
}
